<p>gdo-shared works!</p>
